// extracted by mini-css-extract-plugin
export default {"link":"mAZF70It--FooterLinkSet_link__FMSRh"};